import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";

@observer
export class CopyButton extends Button {

	render() {
		return <Button {...this.props} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M16,6H2v24h18V10L16,6z M18,28H4V8h10v4h4V28z" />
					<polygon points="26,2 12,2 12,4 14,4 22,4 24,4 24,8 28,8 28,24 22,24 22,26 30,26 30,6 " />
				</svg>
			</i>
		</Button>;
	}
}
